import { IconName } from '@infotech-soe/erp-ui-kit';
import { ActionProcessMode } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class RestoreLinksCommand extends CategoryCommand<TActionArgsValues> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.RESTORE_LINK,
    };
  }

  public getIcon(): IconName {
    return 'link';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.CURRENT;
  }

  public getProcessMode(): ActionProcessMode {
    return 'Sequential';
  }
}

export default RestoreLinksCommand;
